.wrapper {
  &.shouldUseBorderOnFallback [data-logo-placeholder] {
    border: 1px solid var(--border-soft);
  }
}
